import { Box, CircularProgress } from '@mui/material';

function Loader() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
      <CircularProgress color="info" />
    </Box>
  );
}

export default Loader;
